import { Action } from '@ngrx/store';
import { FlightSubBookingResponse } from '@shared/models/flight-sub-booking-response.model';
import { TravellerInfoResponse } from './travel-booking.actions';

export const VIEW_FLIGHT_SUB_BOOKING = '[Flight Sub Booking] View flight sub booking';
export const VIEW_FLIGHT_SUB_BOOKING_SUCCESS = '[Flight Sub Booking] View flight sub booking success';
export const VIEW_FLIGHT_SUB_BOOKING_FAILURE = '[Flight Sub Booking] View flight sub booking failure';

export const CREATE_FLIGHT_SUB_BOOKING = '[Flight Sub Booking] Create flight sub booking';
export const CREATE_FLIGHT_SUB_BOOKING_SUCCESS = '[Flight Sub Booking] Create flight sub booking success';
export const CREATE_FLIGHT_SUB_BOOKING_FAILURE = '[Flight Sub Booking] Create flight sub booking failure';
export const PATCH_FLIGHT_SUB_BOOKING_TRAVELLERS = '[Flight Sub Booking] Patch flight sub booking travellers';
export const PATCH_FLIGHT_SUB_BOOKING_TRAVELLERS_SUCCESS =
  '[Flight Sub Booking] Patch flight sub booking travellers success';
export const PATCH_FLIGHT_SUB_BOOKING_TRAVELLERS_FAILURE =
  '[Flight Sub Booking] Patch flight sub booking travellers failure';

export const CLEAR_FLIGHT_SUB_BOOKING = '[Flight Sub Booking] Clear flight sub booking';
export const CLEAR_FLIGHT_TRAVELLER_PATCH = '[Flight Sub Booking] Clear flight traveller patch';

export class ClearFlightSubBooking implements Action {
  readonly type = CLEAR_FLIGHT_SUB_BOOKING;
}

export class ViewFlightSubBooking implements Action {
  readonly type = VIEW_FLIGHT_SUB_BOOKING;
}

export class ViewFlightSubBookingSuccess implements Action {
  readonly type = VIEW_FLIGHT_SUB_BOOKING_SUCCESS;
  constructor(public payload: FlightSubBookingResponse) {}
}

export class ViewFlightSubBookingFailure implements Action {
  readonly type = VIEW_FLIGHT_SUB_BOOKING_FAILURE;
  constructor(public payload: any) {}
}

export class CreateFlightSubBooking implements Action {
  readonly type = CREATE_FLIGHT_SUB_BOOKING;
  constructor() {}
}

export class CreateFlightSubBookingSuccess implements Action {
  readonly type = CREATE_FLIGHT_SUB_BOOKING_SUCCESS;
  constructor(public payload: FlightSubBookingResponse) {}
}

export class CreateFlightSubBookingFailure implements Action {
  readonly type = CREATE_FLIGHT_SUB_BOOKING_FAILURE;
  constructor(public payload: any) {}
}

export class PatchFlightSubBookingTravellers implements Action {
  readonly type = PATCH_FLIGHT_SUB_BOOKING_TRAVELLERS;
  constructor(public payload: any) {}
}

export class PatchFlightSubBookingTravellersSuccess implements Action {
  readonly type = PATCH_FLIGHT_SUB_BOOKING_TRAVELLERS_SUCCESS;
  constructor(public payload: TravellerInfoResponse) {}
}

export class PatchFlightSubBookingTravellersFailure implements Action {
  readonly type = PATCH_FLIGHT_SUB_BOOKING_TRAVELLERS_FAILURE;
  constructor(public payload: any) {}
}

export class ClearFlightTravellerPatch implements Action {
  readonly type = CLEAR_FLIGHT_TRAVELLER_PATCH;
}

export type TravelFlightSubBookingActions =
  | ClearFlightSubBooking
  | ViewFlightSubBooking
  | ViewFlightSubBookingSuccess
  | ViewFlightSubBookingFailure
  | CreateFlightSubBooking
  | CreateFlightSubBookingSuccess
  | CreateFlightSubBookingFailure
  | PatchFlightSubBookingTravellers
  | PatchFlightSubBookingTravellersSuccess
  | PatchFlightSubBookingTravellersFailure
  | ClearFlightTravellerPatch;
